import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function Card({
  children,
  className,
  img,
  alt,
  to,
  href = "#",
  imgHeightClass = "h-60",
}) {
  let image = <div className={`w-full bg-primary ${imgHeightClass}`}></div>;
  if (img) {
    image = (
      <GatsbyImage
        image={getImage(img)}
        className={`w-full group-hover:opacity-50 ${imgHeightClass}`}
        alt={alt}
      />
    );
  }

  let Tag = to ? Link : "a";

  return (
    <Tag
      to={to}
      href={!to ? href : undefined}
      className={`flex flex-col border border-gray-400 group hover:bg-secondary-light ${className}`}
    >
      {image}
      <div className="flex flex-col flex-grow px-4 py-2 group-hover:opacity-50 text-black">
        {children}
      </div>
    </Tag>
  );
}
